module.exports = __webpack_public_path__ + "static/media/p4.5e095375.jpg";